import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import { useHistory, Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext/AuthProvider";
// import { firestore } from '../firebase';
// import 'firebase/firestore';

const SignUp = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const { signup } = useAuth();
    const history = useHistory();
    const passwordRef = useRef();
    const confirmPassRef = useRef();

    const formik = useFormik({
        initialValues: {
            email: "",
            dateOfBirth: "",
            firstName: "",
            lastName: "",
            address: "",
            createdAt: new Date(),
            contact: "",
            displayPicture: "",
        },
        onSubmit: (values) => {
            setError("");
            setLoading(true);
            const { email } = values;
            const password = passwordRef.current.value;
            const userName = `${values.firstName} ${values.lastName}`;
            const confirmPass = confirmPassRef.current.value;
            if (confirmPass === password && values.firstName !== "" && values.lastName !== "") {
                signup(email, password, userName)
                    .then(() => {
                        // firestore.settings({ timestampsInSnapshots: true });
                        // const userRef =
                        // firestore.collection('Admin').doc(ref.user.uid).set(values);
                        formik.resetForm();
                        setLoading(false);
                        history.push("/");
                    })
                    .catch((err) => {
                        setError(err.message);
                        setLoading(false);
                    });
            } else if (confirmPass !== password && values.firstName !== "" && values.lastName !== "") {
                setError("Passwords didn't match!");
                setLoading(false);
            } else {
                setError("All fields are required!");
                setLoading(false);
            }
        },
    });

    // const emailRef = useRef();
    // const userNameRef = useRef();
    // const firstNameRef = useRef();
    // const lastNameRef = useRef();
    // const dateOfBirthRef = useRef();
    // const contactRef = useRef();
    // const addressRef = useRef();

    // const handleSignup = (e) => {
    //   e.preventDefault();
    //   setError("");
    //   setLoading(true);
    //   const email = emailRef.current.value;
    //   const password = passwordRef.current.value;
    //   const userName = userNameRef.current.value;
    //   const confirmPass = confirmPassRef.current.value;
    //   if (confirmPass === password) {
    //     signup(email, password, userName)
    //       .then((ref) => {
    //         setLoading(false);
    //         history.push("/");
    //       })
    //       .catch((err) => {
    //         setError(err.message);
    //         setLoading(false);
    //       });
    //   } else {
    //     setError("Passwords didn't match!");
    //     setLoading(false);
    //   }
    // };

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="signupcont">
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                    }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            textAlign: "left",
                        }}>
                        <h2 className="fontbold">Car Application Admin Registration</h2>
                        {error && <div style={{ color: "red" }}>{error}</div>}
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div className="fontSemi">
                            {loading ? (
                                <button disabled>Signing up...</button>
                            ) : (
                                <button onClick={formik.handleSubmit}>Signup</button>
                            )}
                        </div>

                        <div style={{ marginTop: "0.4rem" }}>
                            or,{" "}
                            <Link to="/login" style={{ textDecoration: "none" }}>
                                <span
                                    style={{
                                        color: "#5d5dff",
                                        cursor: "pointer",
                                    }}>
                                    Login
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
                <br />

                <div className="fontRegular" style={{ display: "flex", flexDirection: "row" }}>
                    <div className="ffc" style={{ marginLeft: "0rem" }}>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <div style={{ flex: "1" }}>
                                <label
                                    htmlFor="firstName"
                                    style={{
                                        width: "7.2rem",
                                        textAlign: "left",
                                        padding: "0rem",
                                    }}>
                                    First name:
                                </label>
                                <input
                                    type="text"
                                    name="firstName"
                                    onChange={formik.handleChange}
                                    placeholder={""}
                                    required
                                />
                            </div>
                            <div style={{ flex: "1" }}>
                                <label htmlFor="username" style={{ width: "7rem" }}>
                                    Last name:
                                </label>
                                <input
                                    type="text"
                                    name="lastName"
                                    onChange={formik.handleChange}
                                    value={formik.values.lastName}
                                    placeholder={""}
                                    required
                                />
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            {/* <div style={{ flex: "1" }}>
                <label
                  htmlFor="dateOfBirth"
                  style={{ width: "7.5rem", padding: "0", textAlign: "left" }}
                >
                  Date of birth:
                </label>
                <input
                  type="date"
                  name="dateOfBirth"
                  onChange={formik.handleChange}
                  value={formik.values.dateOfBirth}
                  placeholder={""}
                  required
                />
              </div> */}
                            <div style={{ flex: "1" }}>
                                <label
                                    htmlFor="username"
                                    style={{
                                        width: "8rem",
                                        textAlign: "left",
                                        padding: "0",
                                    }}>
                                    Address:
                                </label>
                                <input
                                    type="text"
                                    name="address"
                                    onChange={formik.handleChange}
                                    value={formik.values.address}
                                    placeholder={""}
                                    style={{ width: "100%" }}
                                    required
                                />
                            </div>
                        </div>
                        <div>
                            <label
                                htmlFor="contact"
                                style={{
                                    width: "8rem",
                                    textAlign: "left",
                                    padding: "0",
                                }}>
                                Contact:
                            </label>
                            <input
                                type="text"
                                name="contact"
                                style={{ width: "100%" }}
                                onChange={formik.handleChange}
                                value={formik.values.contact}
                                placeholder={""}
                                required
                            />
                        </div>
                        <div>
                            <label
                                htmlFor="email"
                                style={{
                                    width: "8rem",
                                    textAlign: "left",
                                    padding: "0",
                                }}>
                                Email:
                            </label>
                            <input
                                type="email"
                                name="email"
                                style={{ width: "100%" }}
                                onChange={formik.handleChange}
                                value={formik.values.email}
                                placeholder={"username@xyz.com"}
                                required
                            />
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-evenly",
                            }}>
                            <div
                                style={{
                                    flex: "1",
                                    position: "relative",
                                    padding: "0",
                                }}>
                                <label
                                    htmlFor="password"
                                    style={{
                                        width: "9.6rem",
                                        textAlign: "left",
                                        padding: "0",
                                    }}>
                                    Password:
                                </label>
                                <input
                                    type={showNewPassword ? "text" : "password"}
                                    name="password"
                                    ref={passwordRef}
                                    style={{ width: "100%" }}
                                    placeholder={"**********"}
                                    required
                                />
                                {showNewPassword ? (
                                    <i
                                        style={{
                                            marginLeft: "0.5rem",
                                            opacity: "0.5",
                                            cursor: "pointer",
                                            position: "absolute",
                                            right: "2rem",
                                        }}
                                        className="fas fa-eye"
                                        onClick={() => {
                                            setShowNewPassword(!showNewPassword);
                                        }}
                                    />
                                ) : (
                                    <i
                                        style={{
                                            marginLeft: "0.5rem",
                                            opacity: "0.5",
                                            cursor: "pointer",
                                            position: "absolute",
                                            right: "2rem",
                                        }}
                                        className="fas fa-eye-slash"
                                        onClick={() => {
                                            setShowNewPassword(!showNewPassword);
                                        }}
                                    />
                                )}
                            </div>
                            <div style={{ flex: "1", position: "relative" }}>
                                <label htmlFor="password" style={{ width: "12rem", padding: "0" }}>
                                    Confirm password:
                                </label>
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="confpass"
                                    ref={confirmPassRef}
                                    placeholder={"**********"}
                                    required
                                />
                                {showConfirmPassword ? (
                                    <i
                                        style={{
                                            marginLeft: "0.5rem",
                                            opacity: "0.5",
                                            cursor: "pointer",
                                            position: "absolute",
                                            right: "2rem",
                                        }}
                                        className="fas fa-eye"
                                        onClick={() => {
                                            setShowConfirmPassword(!showConfirmPassword);
                                        }}
                                    />
                                ) : (
                                    <i
                                        style={{
                                            marginLeft: "0.5rem",
                                            opacity: "0.5",
                                            cursor: "pointer",
                                            position: "absolute",
                                            right: "2rem",
                                        }}
                                        className="fas fa-eye-slash"
                                        onClick={() => {
                                            setShowConfirmPassword(!showConfirmPassword);
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <br />
                <br />
                <br />
                <br />
                <div className="fontLight" style={{ color: "#acacb9" }}>
                    &copy; Car-Application | 2021
                </div>
            </div>
        </form>
    );
};

export default SignUp;
